import React from 'react';
import { cn } from '@/lib/utils';

const MAP = {
  running: { color: 'bg-[hsl(var(--success))]', label: 'Running', pulse: true },
  idle: { color: 'bg-white/30', label: 'Idle' },
  queued: { color: 'bg-[hsl(var(--info))]', label: 'Queued' },
  paused: { color: 'bg-[hsl(var(--warning))]', label: 'Paused' },
  errored: { color: 'bg-[hsl(var(--danger))]', label: 'Errored' },
  failed: { color: 'bg-[hsl(var(--danger))]', label: 'Failed' },
  completed: { color: 'bg-[hsl(var(--success))]', label: 'Completed' },
  archived: { color: 'bg-white/20', label: 'Archived' },
};

export const StatusDot = ({ state = 'idle', label, className }) => {
  const m = MAP[state] || { color: 'bg-white/30', label: state };
  return (
    <span
      className={cn('inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-xs text-[hsl(var(--text-2))]', className)}
      data-testid={`status-chip-${state}`}
    >
      <span className={cn('relative h-1.5 w-1.5 rounded-full', m.color)}>
        {m.pulse && <span className={cn('absolute inset-0 rounded-full animate-ping opacity-75', m.color)} />}
      </span>
      <span className="tracking-wide">{label || m.label}</span>
    </span>
  );
};
